import "../../../resources/fonts/fonts.css"

    export const TabPanelStyles = {
        marginLeft: "20px",
        marginRight: "20px",
        marginBottom: "20px"
    }
    export const DataGridWrapperStyles = {
        width: "100%",
        height: 600
    }
    export const DataGridStyles = {
        //set color to whiteif dark mode is on or else set to black
        color:
            (theme) => theme.palette.mode === "dark"
                ? "white"
                : "black",
        fontFamily: ["Century "].join(",")
    }
    export const DialogStyles = {
        //set color to whiteif dark mode is on or else set to black
        color:
            (theme) => theme.palette.mode === "dark"
                ? "white"
                : "black",
        fontFamily: ["Century "].join(",")
    }
    export const ButtonStyles = {
        color:
            (theme) => theme.palette.mode === "dark"
                ? "white"
                : "black",
        textTransform: "none",
        fontFamily: ["Century "].join(",")
    }
    export const ContainedButtonStyles = {
        color: "black",
        textTransform: "none",
        fontFamily: ["Century "].join(",")
    }
    export const MaintenanceTitleStyles = {
        paddingBottom: "10px",
        fontWeight: "bold",
        fontFamily: ["Century "].join(",")
    }
    export const ColumnBoxStyles = {
        color:
            (theme) => theme.palette.mode === "dark"
                ? "white"
                : "black",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    }
    export const ColumnBoxBorderStyles = {
        color:
            (theme) => theme.palette.mode === "dark"
                ? "white"
                : "black",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        border: "1px solid black"
    }
    export const RowBoxBorderStyles = {
        color:
            (theme) => theme.palette.mode === "dark"
                ? "white"
                : "black",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        border: "1px solid black"
    }
    export const RowBoxStyles = {
        color:
            (theme) => theme.palette.mode === "dark"
                ? "white"
                : "black",
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    }
